import Image from 'next/image';
import { Page } from '@/payload/payload-types';
import RichTextLexical from '../../_components/RichTextLexical';
import { logToPayload } from '../../_utilities/log-to-payload';

type ReviewsType = Extract<Page['layoutBlocks'][0], { blockType: 'reviews' }>;
type ReviewsProps = Omit<ReviewsType, 'blockType'>;

export const Reviews: React.FC<ReviewsProps> = ({ reviews }) => {
	return (
		<div className="space-y-6">
			{reviews?.map((review, i) => {
				if (typeof review.image === 'string') {
					logToPayload('Bad depth for reviewer image: ', review.name);
					return null;
				}
				return (
					<div
						key={`${review.id}-${i}`}
						className="border-gold-light/30 rounded-2xl border p-8"
					>
						<div className="mb-6 flex">
							<Image
								alt={review.name}
								className="mr-2 rounded-full"
								height={48}
								src={review.image?.sizes?.avatarSmall?.url || '/assets/avatar.jpg'}
								width={48}
								style={{ objectFit: 'cover', height: '48px' }}
							/>
							<div className="flex flex-col justify-center">
								<div>
									<span className="ml-3 font-bold">{review.name}</span>

									<span className="text-brand-medium-grey ml-2 font-normal capitalize">
										{review.role}
									</span>
								</div>
								{review.year && (
									<p className="text-gold ml-3 text-sm">{review.year}</p>
								)}
							</div>
						</div>
						<RichTextLexical content={review.textRichText} />
					</div>
				);
			})}
		</div>
	);
};
